module.exports = __webpack_public_path__ + "static/media/Magic bricks.a37ed711.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Magic bricks.gif
// module id = 354
// module chunks = 0